/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const getDetailsGql = gql`
  query getAvailabilities($slug: String, $input: PublishablePostInput!) {
    getAvailabilities (slug: $slug, input: $input) @rest(
      path: "{args.slug}/availabilities",
      method: "GET"
    ) {
      availabilities
    }
    getDetails (slug: $slug, input: $input) @rest(
      path: "{args.slug}/details",
      method: "GET"
    ) {
      event
      products
    }
    getCheckout (slug: $slug, input: $input) @rest(
      path: "{args.slug}/checkout",
      method: "GET"
    ) {
      invoiceAddress
      lineItems
      useInvoiceDetailsForAttendees
      subtotal
      promoAmount
      taxAmount
      total
      expireDate
    }
  }
`;

export const getFrontendSettingsGql = gql`
  query getFrontendSettings($slug: String, $input: PublishablePostInput!) {
    getDetails (slug: $slug, input: $input) @rest(
      path: "{args.slug}/details",
      method: "GET"
    ) {
      event
    }
  }
`;

export const getTextsGql = gql`
  query getTexts($slug: String, $input: PublishablePostInput!) {
    getTexts (slug: $slug, input: $input) @rest(
      path: "{args.slug}/texts",
      method: "GET"
    ) {
      texts
    }
  }
`;

export const getCheckoutGql = gql`
  query getCheckout($slug: String, $input: PublishablePostInput!) {
    getCheckout (slug: $slug, input: $input) @rest(
      path: "{args.slug}/checkout",
      method: "GET"
    ) {
      invoiceAddress
      lineItems
      useInvoiceDetailsForAttendees
      subtotal
      promoAmount
      taxAmount
      total
      expireDate
      logoUrl
      colors
    }
  }
`;

export const applyCheckoutCouponGql = gql`
  mutation applyCheckoutCoupon($slug: String, $input: PublishablePostInput!) {
    applyCheckoutCoupon (slug: $slug, input: $input) @rest(
      path: "{args.slug}/checkout/coupons",
      method: "POST"
    ) {
      NoResponse
    }
  }
`;

export const removeCheckoutCouponGql = gql`
  mutation removeCheckoutCoupon($slug: String, $input: PublishablePostInput!) {
    removeCheckoutCoupon (slug: $slug, input: $input) @rest(
      path: "{args.slug}/checkout/coupons/remove",
      method: "POST"
    ) {
      NoResponse
    }
  }
`;

export const updateCheckoutGql = gql`
  mutation updateCheckout($slug: String, $input: PublishablePostInput!) {
    updateCheckout (slug: $slug, input: $input) @rest(
      path: "{args.slug}/checkout",
      method: "POST"
    ) {
      NoResponse
    }
  }
`;

export const createPaymentIntentGql = gql`
  mutation createPaymentIntent($slug: String, $input: PublishablePostInput!) {
    createPaymentIntent (slug: $slug, input: $input) @rest(
      path: "{args.slug}/checkout/createPaymentIntent",
      method: "POST"
    ) {
      clientSecret
      status
    }
  }
`;

export const getCheckoutByIdGql = gql`
  query getCheckoutById($slug: String, $externalId: String! $input: PublishablePostInput!) {
    getCheckoutById (slug: $slug, externalId: $externalId, input: $input) @rest(
      path: "{args.slug}/checkout/{args.externalId}",
      method: "GET"
    ) {
      invoiceAddress
      lineItems
      orderNumber
      useInvoiceDetailsForAttendees
      subtotal
      promoAmount
      taxAmount
      total
      expireDate
      paymentStatus
      rsvpInviteUrl
    }
  }
`;
